import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Hook to set up global authentication error interceptor
 * This will automatically logout users when authentication errors occur
 */
export const useAuthInterceptor = () => {
  const { handleAuthError } = useAuth();

  useEffect(() => {
    // Listen for authentication errors from the API
    const handleAuthErrorEvent = (event) => {
      if (event.detail && event.detail.type === 'auth_error') {
        handleAuthError();
      }
    };

    // Add event listener for custom auth error events
    window.addEventListener('auth_error', handleAuthErrorEvent);

    // Cleanup
    return () => {
      window.removeEventListener('auth_error', handleAuthErrorEvent);
    };
  }, [handleAuthError]);
};

export default useAuthInterceptor;
